import React from 'react';

const Login = () => {
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-4xl text-center text-blue-600">Login</h1>
      {/* Add your login form here */}
    </div>
  );
};

export default Login;